<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="姓名">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.name"
        ></a-input>
      </a-form-item>
      <a-form-item label="Logo">
        <UploadFile @callback="uploaded" :mult="false" folder="seller" />
      </a-form-item>
      <a-form-item label="照片">
        <UploadFile @callback="uploaded2" :mult="false" folder="seller" />
      </a-form-item>
      </a-form-item>
      <a-form-item label="简介">
        <a-textarea
          style="width: 600px"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
      <a-form-item label="城市">
        <a-input style="width: 600px" type="text" v-model="form.city"></a-input>
      </a-form-item>
      <a-form-item label="地址">
        <a-input style="width: 600px" type="text" v-model="form.addr"></a-input>
      </a-form-item>
      <a-form-item label="电话">
        <a-input style="width: 600px" type="text" v-model="form.tel"></a-input>
      </a-form-item>
      <a-form-item label="邮件">
        <a-input style="width: 600px" type="text" v-model="form.email"></a-input>
      </a-form-item>
      <a-form-item label="其他联系方式">
        <a-input style="width: 600px" type="text" v-model="form.other_contact"></a-input>
      </a-form-item>
      <a-form-item label="详细介绍">
        <Editor
          @callback="updateEditor"
          :data="form.content"
          folder="seller"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">添加贝商</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import UploadFile from "../../components/uploadFile";
import Editor from "../../components/editor";
import moment from 'moment';

export default {
  components: { UploadFile, Editor },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      form: {
        name: "",
        logo: "",
        photo: "",
        desc: "",
        city: "",
        addr: '',
        tel: '',
        email: '',
        other_contact: '',
        content: ''
      }
    };
  },
  methods: {
    moment,
    async sub() {
      const that = this;
      const r = await that.$axios.post("/seller/create", this.form);

      if (r.status == 1) {
        this.$router.push("/seller/list");
      }
    },

    uploaded(file) {
      this.form.logo = file.file_path;
    },

    uploaded2(file) {
      this.form.photo = file.file_path;
    },
    
    updateEditor(data) {
      this.form.content = data;
    }
  },
};
</script>